import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFieldsCompact from '../../components/form/fieldsCompact';
import Input from '../../components/form/input';

@withText(props => ({
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
}))
@observer
class NewBroadcastChannel extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('broadcastChannel'),
            checkpoints: [],
        };
    }

    createBroadcastChannel = async () => {
        const { callback = () => {} } = this.props;
        const { broadcastChannelStore } = this.props.stores;
        const { newBroadcastChannel } = broadcastChannelStore;
        const response = await broadcastChannelStore.adminCreate(newBroadcastChannel);
        if (response.status === 201) {
            callback();
        }
    }

    loadCheckpoints = async (raceId) => {
        if (!raceId) {
            this.setState({ checkpoints: [] });
            return;
        }
        const { raceClassStore } = this.props.stores;
        await raceClassStore.load({
            query: { race: raceId },
        });
        const { raceClasses } = raceClassStore;
        const allCheckpoints = [];
        for (let i = 0; i < raceClasses.length; i += 1) {
            const rc = raceClasses[i];
            const cps = rc.checkpoints || [];
            for (let j = 0; j < cps.length; j += 1) {
                const cp = cps[j];
                if (cp.lat && cp.lng) {
                    allCheckpoints.push({
                        name: `${rc.title} - ${cp.name}`,
                        lat: cp.lat,
                        lng: cp.lng,
                        rotateDeg: cp.rotateDeg,
                    });
                }
            }
        }
        this.setState({ checkpoints: allCheckpoints });
    }

    handleCopyFromCheckpoint = async (e) => {
        const idx = parseInt(e.target.value, 10);
        if (isNaN(idx) || idx < 0) {
            return;
        }
        const { checkpoints } = this.state;
        const cp = checkpoints[idx];
        if (!cp) {
            return;
        }
        const { isNew } = this.props;
        const { broadcastChannelStore } = this.props.stores;
        const objectName = isNew ? 'newBroadcastChannel' : 'broadcastChannel';
        broadcastChannelStore.updateObjectKeyValue(objectName, 'lat', cp.lat);
        broadcastChannelStore.updateObjectKeyValue(objectName, 'lng', cp.lng);
        broadcastChannelStore.updateObjectKeyValue(objectName, 'rotateDeg', cp.rotateDeg || 0);
        // Persist to API when editing an existing channel
        if (!isNew) {
            const channel = broadcastChannelStore.broadcastChannel;
            if (channel?.id) {
                await broadcastChannelStore.saveField(channel.id, 'lat', cp.lat);
                await broadcastChannelStore.saveField(channel.id, 'lng', cp.lng);
                await broadcastChannelStore.saveField(channel.id, 'rotateDeg', cp.rotateDeg || 0);
            }
        }
    }

    componentDidMount() {
        const { idx, id, isNew } = this.props;
        const { broadcastChannelStore } = this.props.stores;
        if (!isNew) {
            broadcastChannelStore.adminSetFromId(id);
        }
        // Load checkpoints if channel has a race
        const channel = isNew ? broadcastChannelStore.newBroadcastChannel : broadcastChannelStore.broadcastChannel;
        if (channel?.race) {
            this.loadCheckpoints(channel.race);
        }
    }

    componentDidUpdate(prevProps) {
        const { isNew } = this.props;
        const { broadcastChannelStore } = this.props.stores;
        const objectName = isNew ? 'newBroadcastChannel' : 'broadcastChannel';
        const channel = broadcastChannelStore[objectName];
        const prevChannel = prevProps.stores?.broadcastChannelStore?.[objectName];
        if (channel?.race && channel.race !== prevChannel?.race) {
            this.loadCheckpoints(channel.race);
        }
    }

    render() {
        const { week, isNew, drawerLevel } = this.props;
        const { sections, checkpoints } = this.state;
        const { userStore, broadcastChannelStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newBroadcastChannel } = broadcastChannelStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    <h5 class='ms-3 mb-3'>
                        {isNew ? 'New Broadcast Channel' : 'Edit Broadcast Channel'}
                    </h5>
                    {checkpoints.length > 0 && (
                        <div class='mx-3 mb-3'>
                            <label class='form-label small text-body-secondary'>
                                <i class='fa-solid fa-copy me-1' />
                                Kopier GPS fra sjekkpunkt
                            </label>
                            <select class='form-select' onChange={this.handleCopyFromCheckpoint} value=''>
                                <option value=''>-- Velg sjekkpunkt --</option>
                                {checkpoints.map((cp, idx) => (
                                    <option value={idx}>{cp.name} ({util.format(cp.lat, 4)}, {util.format(cp.lng, 4)})</option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                        <FormFieldsCompact stores={this.props.stores} sections={sections} holdingStore={broadcastChannelStore} objectName={isNew ? 'newBroadcastChannel' : 'broadcastChannel'} isNew={isNew} drawerLevel={drawerLevel} isAdmin={true} />
                    </div>
                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createBroadcastChannel}>
                            {isNew ? 'Create Broadcast Channel' : 'Save Broadcast Channel'}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewBroadcastChannel;
